export function getEnvironment() {
  if (typeof window === 'undefined') return 'staging';
  const url = String(window.location);
  if (url.includes('local')) return 'local';
  const isStaging = url.includes('staging');
  if (isStaging) return 'staging';
  if (!isStaging && url.includes('guestit.se')) return 'prod';
  return 'staging';
}

export const errorTypes = {
  network: 'NetworkError',
  graphql: 'GQLError',
  image: 'ImageError',
  i18n: 'TranslationError',
};

export const tags = {
  environment: getEnvironment(),
};
